export default {
  common: {
    account: '帐户',
    return: '返回上一页'
  },
  button: {
    returnTop: '返回首页',
    rangeSelect: '选择乘车区间、时间',
    busSelect: '选择巴士',
    reserveConfirm: '完成预订',
    reserveCancel: '取消预订'
  },
  view: {
    ticket: '车票',
    fromAirport: '机场出发',
    toAirport: '前往机场',
    directionDep: '出发',
    directionDepDesc: '机场 → 目的地',
    directionArr: '抵达',
    directionArrDesc: '目的地 → 机场',
    pleaseSelectBus: '请选择巴士',
    availablePeriod: '可使用期间',
    useInstruction: '使用说明',
    adultCount: '大人 × {{count}}位',
    childCount: '儿童 × {{count}}位',
    disabledAdultCount: '残疾人士(大人) × {{count}}位',
    rangeAndSchedule: '乘车区间及预定乘车日',
    pleaseSelect: '请选择',
    ridingDate: '乘车日',
    ridingPlace: '出发',
    departurePlace: '搭乘地点',
    arrivalPlace: '抵达',
    company: '营运公司',
    availableSeatsCount: '剩余座位',
    ridingBusTime: '巴士行驶时间',
    buyTicket: '票数',
    reservationRideInfo: '订购明细',
    inReserve: '购票处理中，请稍候',
    thankForReservation: '感谢您的购买。',
    reservationConfirmed: '以下订单已完成。',
    inCancel: '取消订单中，请稍候',
    cancelInfo: '取消订单明细',
    isCanceled: '已完成取消订单。',
    notAvailableBus: '找不到所要求区间和乘车日的营运巴士。',
    currentJapanTime: '当前日本时间: {{time}}',
    baseJapanTime: '下面的时间以日本时间为准。',
    remainsCount: '剩余座位数'
  }
};
